import { render } from "./developCenter.vue?vue&type=template&id=12254104&scoped=true"
import script from "./developCenter.vue?vue&type=script&lang=js"
export * from "./developCenter.vue?vue&type=script&lang=js"

import "./developCenter.vue?vue&type=style&index=0&id=12254104&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12254104"]])

export default __exports__